import type from '../commons/templateActionStatus';

const DEFAULT_STATE = {
  templates: [],
  error: null,
  requestState: false,
  status: null,
};

export const templateReducer = (state = DEFAULT_STATE, action) => {
  const actionType = action.type;
  let templates;
  let error = action.error;
  let requestState = action.requestState;
  let status = action.status;
  switch (actionType) {

    case type.GET_ALL_TEMPLATES_REQUEST:
      return { ...state,templates: [], requestState, status };

    case type.GET_ALL_TEMPLATES_SUCCESS:
      templates = action.result;
      return {
        ...state,
        templates,
        requestState,
        status,
      };

    case type.GET_ALL_TEMPLATES_FAILURE:
      return { ...state, error, requestState, status };

          case type.CREATE_TEMPLATE_REQUEST:
      return { ...state, requestState, status };

    case type.CREATE_TEMPLATE_SUCCESS:
      // templates = [action.result];
      return {
        ...state,
        // templates,
        requestState,
        status,
      };

    case type.CREATE_TEMPLATE_FAILURE:
      return { ...state, error, requestState, status };


    default:
      return state;
  }
};
